module.exports = __webpack_public_path__ + "static/media/explore_05.ebcf8d86.jpg";